export const jobTypesItems = [
  { id: '1', label: '立ち仕事' },
  { id: '2', label: '営業職' },
  { id: '3', label: 'デスクワーク' },
  { id: '4', label: '在宅ワーク' },
  { id: '5', label: '主婦・主夫' },
  { id: '6', label: '運転手' },
  { id: '7', label: '医療職' },
  { id: '8', label: 'スポーツ選手' },
  { id: '99', label: 'その他' }
];

export const purposeOfExaminationItems = [
  { id: '1', label: '痛み' },
  { id: '2', label: '痺れる' },
  { id: '3', label: '疲れやすい' },
  { id: '4', label: 'むくみ' },
  { id: '5', label: '姿勢が気になる' },
  { id: '6', label: '足の形が気になる' },
  { id: '7', label: '歩行に問題がある' },
  { id: '99', label: 'その他' }
];

export const workplaceTransferMethodItems = [
  { id: '1', label: 'なし' },
  { id: '2', label: '徒歩' },
  { id: '3', label: '電車' },
  { id: '4', label: 'バス' },
  { id: '5', label: '自転車' },
  { id: '6', label: '車' },
  { id: '7', label: 'タクシー' },
  { id: '8', label: 'バイク' },
  { id: '99', label: 'その他' }
];

export const walkingHabitItems = [
  { id: '1', label: '良く歩く方だ' },
  { id: '2', label: '必要最低限は歩く' },
  { id: '3', label: 'あまり歩かない' },
  { id: '4', label: '全く歩かない' }
];

export const aidsForWalkingItems = [
  { id: '1', label: '独歩' },
  { id: '2', label: '杖' },
  { id: '3', label: 'バギー/シルバーカー' },
  { id: '4', label: '車椅子/歩けない' }
];

export const createdInHospitalsAndClinicsItems = [
  { id: '1', label: '特になし' },
  { id: '2', label: 'インソール(靴底板)' },
  { id: '3', label: '靴' },
  { id: '4', label: 'その他装具' }
];

export const diseasesRelatedToOrthopedicsItems = [
  { id: '1', label: 'なし' },
  { id: '2', label: '扁平足' },
  { id: '3', label: '凹足' },
  { id: '4', label: '外反母趾' },
  { id: '5', label: '内反小趾' },
  { id: '6', label: '強剛母指' },
  { id: '7', label: 'モートン病' },
  { id: '8', label: '足底筋膜炎' },
  { id: '9', label: '後縦靭帯骨化症' },
  { id: '10', label: '変形性足関節症' },
  { id: '11', label: '先天性内反足' },
  { id: '12', label: '変形性股関節症' },
  { id: '14', label: '先天性股関節脱臼' },
  { id: '15', label: 'ペルテス病' },
  { id: '16', label: '変形性膝関節症' },
  { id: '17', label: '膝関節半月板損傷' },
  { id: '18', label: '臼蓋形成不全' },
  { id: '19', label: '変形性頚椎症' },
  { id: '20', label: '頚椎症性脊髄症' },
  { id: '21', label: '変形性胸椎症' },
  { id: '22', label: '黄色靭帯骨化症' },
  { id: '24', label: '頸椎椎間板ヘルニア' },
  { id: '25', label: '腰部脊柱管狭窄症' },
  { id: '26', label: '小児整形' },
  { id: '27', label: '骨粗鬆症' },
  { id: '28', label: '捻挫' },
  { id: '29', label: '骨折' },
  { id: '99', label: 'その他' }
];

export const otherAllergiesItems = [
  { id: '1', label: 'なし' },
  { id: '2', label: '花粉症' },
  { id: '3', label: '金属' },
  { id: '4', label: '食物' },
  { id: '5', label: '動物' },
  { id: '6', label: 'ハウスダスト' },
  { id: '7', label: '喘息' },
  { id: '99', label: 'その他' }
];

export const medicationsCurrentlyBeingTakenItems = [
  { id: '1', label: 'なし' },
  { id: '2', label: '血圧のくすり' },
  { id: '3', label: '不整脈のくすり' },
  { id: '4', label: '血液をさらさらにするくすり' },
  { id: '5', label: 'ステロイド' },
  { id: '6', label: '糖尿病のくすり' },
  { id: '7', label: 'インスリン' },
  { id: '8', label: '痛み止め' },
  { id: '9', label: '睡眠薬' },
  { id: '99', label: 'その他' }
];

export const aboutCigarettesItems = [
  { id: '1', label: '吸ったことがない' },
  { id: '2', label: '吸っている' },
  { id: '3', label: 'やめた' }
];

export const aboutAlcoholItems = [
  { id: '1', label: '飲まない' },
  { id: '2', label: 'ほとんど飲まない' },
  { id: '3', label: '週に1回' },
  { id: '4', label: 'ほとんど毎日' },
  { id: '5', label: '毎日' }
];

export const primaryNursingCareRequirementAuthorizationItems = [
  { id: '1', label: '持っていない' },
  { id: '2', label: '要支援1' },
  { id: '3', label: '要支援2' },
  { id: '4', label: '要介護1' },
  { id: '5', label: '要介護2' },
  { id: '6', label: '要介護3' },
  { id: '7', label: '要介護4' },
  { id: '8', label: '要介護5' }
];
